import { availableUtilityProviders_availableUtilityProviders_utilityProviders as UtilityType } from 'types/generated/availableUtilityProviders';

/**
 * @module groupedUtilityMap
 * @description group utilities by kind into a Map
 * @param {UtilityType[]} list - utilities array
 * @returns {Map}
 */

const groupedUtilityMap = (list: UtilityType[]) =>
  list.reduce(
    (entryMap, e) => entryMap.set(e.kind, [...(entryMap.get(e.kind) || []), e]),
    new Map()
  );

/**
 * @module pickUtilities
 * @description picks the utilities shown to the user
 * @param {UtilityType[]} list - utilities array
 * @returns {Array<Object>}
 */

const pickUtilities = (list: UtilityType[]): UtilityType[] => {
  const groupedUtilities = groupedUtilityMap(list);
  const gas = groupedUtilities.get('gas');
  const electric = groupedUtilities.get('electric');
  const water = groupedUtilities.get('water');

  return [gas, electric, water]
    .filter((elem) => Boolean(elem))
    .map((elem) => elem.shift());
};

export default pickUtilities;
